import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=dec2cb7e&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec2cb7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dec2cb7e')) {
      api.createRecord('dec2cb7e', component.options)
    } else {
      api.reload('dec2cb7e', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=dec2cb7e&scoped=true&", function () {
      api.rerender('dec2cb7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2n1n1Tw2dFAm3/JS/comp/Accordion.vue"
export default component.exports